import React from 'react';
import { useWeb3 } from '../context/Web3Context';
import { shortAddr } from '../utils/format';

export default function AccessRestricted() {
  const { account, disconnect } = useWeb3();
  return (
    <div className="connect-wrap fade-in">
      <div className="avatar" style={{ width: 84, height: 84, background: 'linear-gradient(135deg,#ff5a5f,#b9820c)' }}>
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="#1a1404" strokeWidth="2" />
          <path d="M6 6l12 12" stroke="#1a1404" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      <h1 style={{ fontSize: 26 }}>Access Restricted</h1>
      <p>This account has been suspended and cannot access the platform. If you believe this is a mistake, please contact support.</p>
      <p className="dim" style={{ fontSize: 12 }}>{shortAddr(account)}</p>
      <button className="btn ghost" style={{ maxWidth: 240 }} onClick={disconnect}>Disconnect</button>
    </div>
  );
}
